import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { DialogHelper } from "../core/util/dialogHelper";
import { SheetEventType } from "../../siteManagement/sheet";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { Dialog, DialogProps } from "../core/components/dialog";
import React from "react"

export default class CRQuestion extends React.Component<CRQuestionProps, CRQuestionState> {
    common = new AppHelper();
    possibleValuesGridOptions = [];
    tagsGridOptions = [];
    titlesGridOptions = [];
    possibleValuesAreUsed = false;
    unitAreUsed = false;
    private _isValid: {
        possibleValues: boolean;
        titles: boolean;
    };
    private _dialogProps: DialogProps = {
        title: "Draft Avaibable",
        actions: [
            {
                label: "Show released version",
                action: () => { }
            },
            {
                label: "Edit draft",
                action: () => {
                    this._openDraft();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.props.context.possibleValuesGridOptions = this.possibleValuesGridOptions;
        this.props.context.tagsGridOptions = this.tagsGridOptions;
        this._isValid = { possibleValues: true, titles: true };
        this._setEvents();
        this.possibleValuesAreUsed = Helper.hasValue(this.props.entity.PossibleValues) && this.props.entity.PossibleValues.length > 0
        this.unitAreUsed = !Helper.isNullOrEmpty(this.props.entity.UnitId);
        this.state = {
            dialogOpen: false
        };
    }

    private _createDialog = () => {
        this._createFancyText();
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    {this._createFancyText()}
                </Dialog>
            </div>
        );
    }

    private _createFancyText = () => {
        const style: React.CSSProperties = {
            fontSize: "18.6px",
            display: "block",
            cursor: "default",
            boxSizing: "content-box",
            color: "#333333"
        };

        return (
            <div style={style} key={kendo.guid()}>
                {Helper.getTranslation("WebSMS.Report.Question.Dialog.Title")}
            </div>
        );

    }

    private _openDraft = () => {
        this.props.changeRoute(this.props.draftId);
    }

    private _checkValidation = () => {
        this._checkTitles();
        let result = true;
        if (!this.common.validate()) {
            result = false;
        }
        if (!this._isValid.titles && Helper.isNullOrEmpty(this.props.entity.Title)) {
            NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.Report.Question.Messages.TitlesNotTranslated"));
            result = false;
        }
        if (!this._isValid.possibleValues) {
            NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.Report.Question.Messages.InvalidValues"));
            result = false;
        }
        return result;
    }

    private _checkTitles = () => {
        this._isValid.titles = false;
        const titles = this.props.entity.Titles.slice(0);
        this._isValid.titles = ((titles.filter(f => !Helper.isNullOrEmpty(f.Value)).length > 0) || !Helper.isNullOrEmpty(this.props.entity.Title));
    }

    private _setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus: { command: string, isValid: boolean, value: any }) => {

            switch (cus.command) {
                case ("possibleValuesChanged"):
                    this.possibleValuesAreUsed = Helper.hasValue(cus.value) && (cus.value as []).length > 0;
                    this._isValid.possibleValues = cus.isValid;
                    this.common.setEntityDirtyState(true);
                    break;
                case ("titlesChanged"):
                case ("gridDataChanged"):
                    this.common.setEntityDirtyState(true);
                    break;
            }
            this.setState({})
        });
    }

    save = async (closeAfterSave) => {
        if (this._checkValidation()) {
            const result = await HTTPService.post<JsonResultClass<CRQuestionEntity>>("CRQuestion/Save", { model: this.props.entity });
            if (result.Code === 0) {
                if (!this.props.entity.ISGuid) {
                    General.Functions.HistoryState.replaceState("CRQuestion/Edit?Id=" + result.Data.ISGuid);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.ISGuid", result.Data.ISGuid);
                }
                //Helper.updateEntity(this.props.entity, result.Data);
                this.setState({});
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
            this.setState({});
        }
    }

    copy = async () => {
        const result = await DialogHelper.confirm(Helper.getTranslation("WebSMS.Report.Question.ShouldCopyQuestion"), 500);
        if (result) {
            const copiedQuestion = { ...this.props.entity, ISGuid: null };
            const result = await HTTPService.post<JsonResultClass<CRQuestionEntity>>("CRQuestion/Save", { model: copiedQuestion, isClone: true });
            if (Helper.hasValue(result.AdditionalData) && result.AdditionalData["unitIsDeleted"]) {
                NotificationHelper.showInfoMessage(Helper.getTranslation("WebSMS.Report.Question.UnitIsDeletedCopy"));
            }
            if (result.Code == 0) {
                this.props.changeRoute(result.Data.ISGuid);
                this.common.handlePostSave(true, false);
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    release = async () => {
        await this.save(false);
        const result = await HTTPService.get<JsonResultClass<CRQuestionEntity>>("CRQuestion/Release?Id=" + this.props.entity.ISGuid);
        if (result.Code === 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            Helper.updateEntity(this.props.entity, result.Data)
            let sheet = General.Sheet.Manager.getTopMostSheet();
            sheet.trigger(SheetEventType.Custom, { command: "entityStatusChanged", value: false });
            this.setState({});
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    remove = async () => {
        const isOK = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
        if (isOK) {
            const result = await HTTPService.get<JsonResultClass<CRQuestionEntity>>("CRQuestion/Delete?Id=" + this.props.entity.ISGuid);
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                setTimeout(() => {
                    this.common.handlePostSave(result.Code === 0, false);
                    General.Sheet.Manager.getTopMostSheet().hide();
                }, 1000);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    disable = async () => {
        const isOK = await DialogHelper.confirm(Helper.getTranslation("Standard.SollFrageDeaktiviertWerden"));
        if (isOK) {
            const result = await HTTPService.get<JsonResultClass<CRQuestionEntity>>("CRQuestion/Disable?Id=" + this.props.entity.ISGuid);
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                setTimeout(() => {
                    this.common.handlePostSave(result.Code === 0, false);
                    General.Sheet.Manager.getTopMostSheet().hide();
                }, 1000);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    createNewVersion = async () => {
        const isOK = await DialogHelper.confirm(Helper.getTranslation("WebSMS.Report.Question.AskForUpdate"));
        if (isOK) {
            const result = await HTTPService.post<JsonResultClass<CRQuestionEntity>>("CRQuestion/CreateNewVersion", { model: this.props.entity })
            if (Helper.hasValue(result.AdditionalData) && result.AdditionalData["unitIsDeleted"]) {
                NotificationHelper.showInfoMessage(Helper.getTranslation("WebSMS.Report.Question.UnitIsDeletedNewVersion"));
            }
            if (result.Code === 0) {
                this.props.changeRoute(result.Data.ISGuid);
                this.common.handlePostSave(true, false);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    };


    componentDidMount() {
        this._dialogProps.title = Helper.getTranslation("WebSMS.Report.Question.Dialog.DraftAvailable");
        this._dialogProps.actions[0].label = Helper.getTranslation("WebSMS.Report.Question.Dialog.ShowReleased");
        this._dialogProps.actions[1].label = Helper.getTranslation("WebSMS.Report.Question.Dialog.EditDraft");
        this.setState({ dialogOpen: Helper.hasValue(this.props.draftId) });
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.DataType":
                const dataType = value as DataTypes;
                if (!Helper.isNullOrEmpty(this.props.entity.UnitId) && ((this.props.entity.DataType == DataTypes.int) || (this.props.entity.DataType == DataTypes.float)) && ((value != DataTypes.int) || (value != DataTypes.float)))
                    this.handleFieldChange({ model: "entity.UnitId" }, null)
                let sheet = General.Sheet.Manager.getTopMostSheet();
                sheet.trigger(SheetEventType.Custom, { command: "dataTypeChanged", value: dataType });
                break;
            case "entity.UnitId":
                this.unitAreUsed = !Helper.isNullOrEmpty(value);
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return (
            <>
                <CommonApp {...props} />
                {dialog}
            </>
        );
    }

}

export interface CRQuestionProps extends AppBaseProps {
    entity: CRQuestionEntity;
    context: CRQuestionContext;
    draftId: string;
    reloadTab?: any;
    changeRoute?: any
}

export interface CRQuestionState {
    dialogOpen: boolean;
}

export interface CRQuestionEntity extends Entity {
    ISGuid: string;
    Title: string;
    Titles: CRTranslation[];
    Released: boolean;
    PossibleValues: CRKeyValuePair[];
    DataType: DataTypes;
    FilterScript: string;
    Tags: {
        Key: number;
        Value: string;
    };
    IsDeleteable: boolean;
    UnitId?: string;
}

export interface CRKeyValuePair {
    Id: string;
    Value: any;
    DisplayText: string;
    Translations: CRTranslation[];
}

export interface CRTranslation {
    Key: Language;
    Value: string;
}

export interface Language {
    Id: number;
    Name: string;
}

export enum DataTypes {
    string, int, float, boolean, dateTime, date
}

export interface CRQuestionContext extends Context {
    translations?: Array<string>;
    possibleValuesGridOptions?: any;
    tagsGridOptions?: any;
}

